import { Controller } from "@hotwired/stimulus"
import { nativeRequestPush } from "../utils/native_bridge"

// Native APNs enrollment from Settings → General (replaces Web Push UI in turbo-native).
export default class extends Controller {
    static targets = ["status", "badge", "enableButton"]

    connect() {
        if (!document.body.classList.contains("turbo-native")) return
        this._onRegistered = () => this.showState("subscribed")
        window.addEventListener("native:push-registered", this._onRegistered)
        this.showState("ready")
    }

    disconnect() {
        if (this._onRegistered) window.removeEventListener("native:push-registered", this._onRegistered)
    }

    enable() {
        nativeRequestPush()
        this.showState("pending")
    }

    showState(state) {
        const messages = {
            ready: "Get notified when the assistant replies, a task is due, or someone messages you.",
            pending: "Waiting for permission…",
            subscribed: "This iPhone will receive push notifications from Jane.",
            denied: "Notifications are off. Enable them in iOS Settings → Jane → Notifications."
        }
        if (this.hasStatusTarget) this.statusTarget.textContent = messages[state] || ""
        if (this.hasBadgeTarget) {
            const on = state === "subscribed"
            this.badgeTarget.textContent = on ? "On" : "Off"
            this.badgeTarget.classList.toggle("bg-success", on)
            this.badgeTarget.classList.toggle("bg-secondary", !on)
        }
        if (this.hasEnableButtonTarget) this.enableButtonTarget.hidden = state === "subscribed" || state === "pending"
    }
}
